module.exports = __webpack_public_path__ + "static/media/05.d39d7541.mp3";